import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Calendar, TrendingUp, Zap, Bot } from "lucide-react";

const AISection = () => {
  return (
    <div className="container bg-light py-5">
      <div className="row align-items-center g-5">
        {/* Left Content */}
        <div className="col-lg-6">
          <button className="btn btn-outline-warning rounded-pill px-3 py-1 mb-4 d-flex align-items-center gap-2">
            <Bot size={18} /> KI-Powered
          </button>

          <h2 className="fw-bold display-5 mb-3">Euer intelligenter Familien-Assistent</h2>

          <p className="text-secondary fs-5 mb-4">
            Der KI-Agent im Hintergrund denkt mit: Er erstellt Einkaufslisten aus eurem Essensplan,
            findet Konflikte im Kalender und schlägt Lösungen vor – bevor ihr selbst daran denkt.
          </p>

          <div className="d-flex flex-column gap-4 mt-4">
            <div className="d-flex align-items-start gap-3">
              <div className="bg-primary bg-opacity-10 p-3 rounded-4">
                <Calendar size={24} className="text-primary" />
              </div>
              <div>
                <h5 className="fw-bold mb-1">Automatische Planung</h5>
                <p className="text-secondary mb-0">Schlägt optimale Zeitslots für Aktivitäten vor</p>
              </div>
            </div>

            <div className="d-flex align-items-start gap-3">
              <div className="bg-primary bg-opacity-10 p-3 rounded-4">
                <TrendingUp size={24} className="text-primary" />
              </div>
              <div>
                <h5 className="fw-bold mb-1">Erkennt Muster</h5>
                <p className="text-secondary mb-0">Lernt aus euren Gewohnheiten und passt sich an</p>
              </div>
            </div>

            <div className="d-flex align-items-start gap-3">
              <div className="bg-primary bg-opacity-10 p-3 rounded-4">
                <Zap size={24} className="text-primary" />
              </div>
              <div>
                <h5 className="fw-bold mb-1">Proaktive Hilfe</h5>
                <p className="text-secondary mb-0">Findet Terminüberschneidungen, bevor sie zum Problem werden</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Chat Box */}
        <div className="col-lg-6">
          <div className="p-4 rounded-4 shadow-sm bg-white" style={{ borderRadius: "20px" }}>
            <div className="d-flex align-items-start gap-3 mb-4">
              <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                <Bot size={22} className="text-primary" />
              </div>
              <div className="bg-light p-3 rounded-4 flex-grow-1">
                Ich habe bemerkt, dass ihr am Montag Pasta geplant habt. Soll ich Nudeln und
                Tomatensoße zur Einkaufsliste hinzufügen?
              </div>
            </div>

            <div className="d-flex justify-content-end mb-4">
              <div className="bg-primary text-white p-3 rounded-4">
                Ja bitte, aber nimm Bio-Nudeln 🍝
              </div>
            </div>

            <div className="d-flex align-items-start gap-3">
              <div className="bg-primary bg-opacity-10 p-3 rounded-circle">
                <Bot size={22} className="text-primary" />
              </div>
              <div className="bg-light p-3 rounded-4 flex-grow-1">
                Erledigt! ✓ Bio-Nudeln und Tomatensoße sind auf der Einkaufsliste.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AISection;